import { render, staticRenderFns } from "./WettkampfListe.vue?vue&type=template&id=2851ee13&scoped=true&"
import script from "./WettkampfListe.vue?vue&type=script&lang=js&"
export * from "./WettkampfListe.vue?vue&type=script&lang=js&"
import style0 from "./WettkampfListe.vue?vue&type=style&index=0&id=2851ee13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2851ee13",
  null
  
)

export default component.exports